export default {"src":"/_next/static/media/500.40b1bd79.gif","height":384,"width":691,"blurWidth":0,"blurHeight":0};